import { forwardRef } from "react";

import { useRouter } from "next/router";
import PropTypes from "prop-types";

import usePresentModeContext from "@/view/utils/usePresentModeContext";
import PresentModeBanner from "./PresentModeBanner";
import PreviewModeBanner from "./PreviewModeBanner";

const propTypes = {
  content: PropTypes.object,
  toggleBannerMode: PropTypes.func,
};

const ViewPageBanner = forwardRef(
  ({ content, toggleBannerMode }, bannerRef) => {
    const router = useRouter();
    const { query } = router;
    const { preview_for: previewFor } = query;

    const { isPresentModeActive, setIsPresentModeActive } =
      usePresentModeContext();

    if (isPresentModeActive) {
      return (
        <PresentModeBanner
          contentId={content.id}
          contentType={content.content_type}
          handleToggleBannerMode={toggleBannerMode}
          bannerRef={bannerRef}
          setIsPresentModeActive={setIsPresentModeActive}
        />
      );
    }

    return (
      <PreviewModeBanner
        bannerRef={bannerRef}
        contentId={content.id}
        contentType={content.content_type}
        handleToggleBannerMode={toggleBannerMode}
        previewFor={previewFor}
      />
    );
  },
);

ViewPageBanner.propTypes = propTypes;
export default ViewPageBanner;
